module.exports = __webpack_public_path__ + "static/media/waiting.6dec01bd.svg";